import { IPrivateChannel } from '@core/chat/StreamChat/interfaces';
import {
  ChatTabs,
  CheckIsGlobalTabType,
  CheckIsBroadcastTabType,
} from '@core/chat/interfaces';

export const getExistedPrivateChannel = (
  privateChannels: IPrivateChannel[],
  participantUserId: string,
): IPrivateChannel | undefined => {
  // TODO: UEF-5469 Investigate why some items in privateChannels are undefined
  const privateChannel = privateChannels
    .filter((x) => x.channel)
    .find(({ userIds }) => userIds.includes(participantUserId));

  return privateChannel;
};

export const getPrivateChannelId = (streamChannelId: string) => {
  const streamChannelIdArray = streamChannelId.split('-');
  const privateChannelId =
    streamChannelIdArray[streamChannelIdArray.length - 1];

  return privateChannelId;
};

export const checkChannelFormCurrentEvent = (
  streamChannelId: string,
  currentEventId: string,
): boolean => {
  const isCurrentEventChannel = streamChannelId.includes(currentEventId);

  return isCurrentEventChannel;
};

export const checkIsEventChannel = (
  streamChannelId: string,
  eventId: string,
): boolean => streamChannelId === `mytaverse-event-${eventId}`;

export const checkIsRoomChannel = (
  streamChannelId: string,
  roomId: string,
): boolean => streamChannelId === `mytaverse-room-${roomId}`;

export const checkIsGlobalTab: CheckIsGlobalTabType = (tab) =>
  tab === ChatTabs.Global;

export const checkIsBroadcastTab: CheckIsBroadcastTabType = (tab) =>
  tab === ChatTabs.Broadcast;
